import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { observer } from 'mobx-react';

class EstimateForm extends Component {
  handleChangeQty = event => {
    const parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.estimate.setQty(parsedValue)
  }
  handleChangeMargin = event => {
    const parsedInt = parseInt(event.target.value, 10)
    if (!isNaN(parsedInt)) {
      const multiplier = (parsedInt / 100) + 1
      this.props.estimate.setMultiplier(multiplier)
    }
  }
  handleChangeHourlyRate = event => {
    const parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.estimate.setDollarsPerHour(parsedValue)
  }
  selectAll = event => event.target.select()
  render() {
    const estimate = this.props.estimate
    return (
      <Form as='div'>
        <Form.Group widths='equal'>
          <Form.Input
            label='Qty'
            type='number' 
            min='1'
            placeholder='Qty'
            value={estimate.qty}
            onChange={this.handleChangeQty}
            onFocus={this.selectAll}
            readOnly={this.props.readOnlyQty}
          />
          <Form.Input
            label='Margin %'
            type='number'
            value={estimate.multiplierAsPercentage}
            onChange={this.handleChangeMargin}
            onFocus={this.selectAll}
          />
          <Form.Input
            label='Hourly rate'
            type='number'
            value={estimate.dollarsPerHour}
            onChange={this.handleChangeHourlyRate}
            onFocus={this.selectAll}
          />
        </Form.Group>
      </Form>
    )
  }
}
 
export default observer(EstimateForm);


// WEBPACK FOOTER //
// ./src/components/jobs/EstimateForm.js